export default "__VITE_ASSET__CEK$Jobr__"